import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultColor", "disabled", "label", "size", "className", "style"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../../Text";
import styles from "../styles.pcss";
import { getColor, getTextSettings } from "./utils";
var cnCellText = cnBem('cell-text', styles);
export var CellText = /*#__PURE__*/forwardRef(function (props, ref) {
  var defaultColor = props.defaultColor,
    disabled = props.disabled,
    label = props.label,
    _props$size = props.size,
    size = _props$size === void 0 ? 's' : _props$size,
    className = props.className,
    style = props.style,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (!label) {
    return null;
  }
  var _getTextSettings = getTextSettings(label),
    text = _getTextSettings.text,
    truncate = _getTextSettings.truncate,
    rows = _getTextSettings.rows,
    color = _getTextSettings.color;
  return /*#__PURE__*/React.createElement(Text, _extends({}, otherProps, {
    className: cnCellText(null, [className]),
    color: getColor(disabled, defaultColor, color),
    ref: ref,
    rows: rows,
    tagName: "span",
    truncate: truncate,
    variant: size === 's' ? 'body-small' : 'body-large'
  }), text);
});